// Free preview signs: Stoppskylt + Ingen omkörning first, then a mix by category.
const FEATURED_FREE_SIGNS = [
  { id: '9f830a97-428e-4688-9577-3667f26768d0', sv: 'Stoppskylt' },
  { id: 'ff938e47-694a-4168-bf77-a432879f486e', sv: 'Ingen omkörning' },
];
const CATEGORY_ORDER = ['priority', 'prohibition', 'warning', 'mandatory', 'speed', 'highway', 'residential', 'pedestrian_cycling', 'parking', 'informative'];

export const getPreviewSignIds = (signs, count = 3) => {
  if (!signs?.length) return [];
  const picked = FEATURED_FREE_SIGNS
    .map((f) => signs.find((x) => x.id === f.id || x.name === f.sv || x.name?.sv === f.sv))
    .filter(Boolean);
  const byCat = CATEGORY_ORDER.map((c) => signs.filter((s) => s.category === c));
  for (let i = 0; picked.length < count && byCat.some((l) => l[i]); i++) {
    for (const list of byCat) {
      if (list[i] && picked.length < count && !picked.includes(list[i])) picked.push(list[i]);
    }
  }
  return picked.slice(0, count).map((s) => s.id);
};
